<template>
  <f7-page>
    <f7-navbar v-bind:title="courseName" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <header class="wave-header sticky-top">
      <div class="course-content">
        <f7-row>
          <div
            class="avatar"
          ></div>
          <div class="name">
            <h3>{{ name }}</h3>
            <p>
              <span>選課代碼 {{ courseCode }}</span>
              <!--
              <span>・</span>
              <span>課程代號 {{ courseCode }}</span>
              -->
            </p>
          </div>
        </f7-row>
      </div>
    </header>

    <!-- 學生的-->
    <template v-if="!loadingFlag">
    <div class="student-medium-status">
      <!-- 等待對方確認中 -->
      <section v-if="applyStatus==10">
        <h1>等待對方確認中</h1>
        <div class="item-inner hint">
          請以 email 與對方確認上課資訊，
          <br />例如上課地點、上課時間。
        </div>
      </section>
      <!-- 已取消 -->
      
      <section v-if="applyStatus==80">
        <h1>已取消</h1>
        <p class="item-inner hint">張嘉佳已取消這次的課程媒合</p>
        <!--
        <div class="block">
          <button
            @click="checkHref('medium-detail-student')"
            class="button button-outline button-round"
          >刪除此紀錄</button>
        </div>
        -->
      </section>
    </div>
    </template>
  </f7-page>
</template>

<script>
import Service from "../../../service";

import axios from '../../../js/axiosModule.js';
import { bus } from '../../../js/bus';
// 10 wait
//
export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      name:this.$store.state.userInfo.chineseName,
      id:'',
      setYear:'',
      setTerm:'',
      tutor:'',
      tutee:'',
      courseCode:'',
      courseName:'',
      applyStatus:'',
      courseEndAt:'',
      note:'',
      searchTerm:'',
      createdBy:'',
      createdAt:'',
      updatedBy:'',
      updatedAt:'',
      loadingFlag:false

    };
  },

  created: function() {
    let self = this;
    bus.$on('detail-student',function(res){
      //console.log();
      self.loadingFlag = true;
      self.id = res.id;
      self.setYear = res.setYear;
      self.setTerm = res.setTerm;
      self.tutor = res.tutor;
      self.tutee = res.tutee;
      self.courseCode = res.courseCode;
      self.courseName = res.courseName;
      self.applyStatus = res.applyStatus;
      self.courseEndAt= res.courseEndAt;
      self.note = res.note;
      self.searchTerm = res.searchTerm;
      self.createdBy = res.createdBy;
      self.createdAt = res.createdAt;
      self.updatedBy = res.updatedBy;
      self.updatedAt = res.updatedAt;
      self.loadingFlag = false;

    });

  },
  mounted() {},
  methods: {
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/medium/medium-detail-student.vue